import { Set } from 'immutable'
import { HttpResult } from 'widgets-for-react'
import { Alphabetized } from '../azNavigation/azNavigationUtils'
import { ProcessedResearch, ResearchWithDepartments, ResearchPerDepartment, Research } from './researchOverviewState'

const filterAndQuery = (
  data: ResearchWithDepartments[],
  department: string,
  query: string
): ResearchWithDepartments[] =>
  data.filter(
    (x) =>
      (department == '' || x.departments.some((d) => d.toLowerCase() == department.toLowerCase())) &&
      (query == '' ||
        x.title.toLowerCase().includes(query.toLowerCase()) ||
        x.topic.toLowerCase().includes(query.toLowerCase()) ||
        x.intro?.toLowerCase().includes(query.toLowerCase()))
  )

export const groupByForResearch = (arr: ResearchWithDepartments[]): Alphabetized<ResearchPerDepartment> => {
  const researchMap = new Map<string, Research[]>()
  const resultMap = new Map<string, ResearchPerDepartment[]>()

  arr.map((page) => {
    page.departments.map((department) => {
      const getItem = researchMap.get(department)
      if (getItem != undefined) {
        researchMap.set(department, getItem.concat([page]))
      } else {
        researchMap.set(department, [page])
      }
    })
  })

  researchMap.forEach((value, key) => {
    const getItem = resultMap.get(key[0])
    if (getItem != undefined) {
      resultMap.set(key[0], getItem.concat({ department: key, research: value }))
    } else {
      resultMap.set(key[0], [{ department: key, research: value }])
    }
  })

  const res: Alphabetized<ResearchPerDepartment> = []

  resultMap.forEach((value, key) => {
    res.push({ letter: key, items: value })
  })

  res.sort((a, b) => {
    if (a.letter > b.letter) {
      return 1
    }
    if (a.letter < b.letter) {
      return -1
    }
    return 0
  })

  res.map((perLetter) => {
    perLetter.items.sort((a, b) => {
      if (a.department > b.department) {
        return 1
      }
      if (a.department < b.department) {
        return -1
      }
      return 0
    })
  })
  return res
}

// Constructs alphabetically grouped, alphabetically sorted by department list of research
export const processResearch = async (
  data: ResearchWithDepartments[],
  department: string,
  query: string
): Promise<HttpResult<ProcessedResearch>> => {
  const departments = data.reduce<Set<string>>((acc, r) => acc.concat(r.departments), Set())

  const filtered = filterAndQuery(data, department, query)

  const groups = groupByForResearch(filtered)

  return {
    kind: 'result',
    status: 200,
    value: { departments, groups },
  }
}
